import styled from 'styled-components';
import { COLORS } from '@r1-frontend/ui-react/assets/js/constants';
import GridContainer from '@r1-frontend/ui-react/components/layouts/gridContainer';
import { FlexBoxRow } from '@r1-frontend/ui-react/components/layouts/flexBoxGrid';
import { fonts } from '~/src/helpers/font';
import { blockMargin, breakPoints, CSSPropWithBreakpoints, styleWithBreakPoints } from '~/src/components/LandingBlock/styled';

export interface IBgBlockStyles {
    [key: string]: CSSPropWithBreakpoints;
}

export const Wrapper = styled.div<{ [key: string]: string }>`
    display: flex;
    width: 100%;
    color: ${COLORS.white};
    background: ${p => p.background ? `url(${p.background}) no-repeat center / cover` : 'transparent'};
    transition: all 1.5s ease 0s;
    overflow: hidden;
            
    &:hover {
        background-size: 104% 154%;

        @media (max-width: ${breakPoints.tablet}) {
            background-size: 100% 150%;
        }

        @media (max-width: 425px) {
            background-size: 100% 100%;
        }
    }

    @media (max-width: 425px) {
        background-size: 100% 100%;
    }
    
    ${p => blockMargin(p)};
    ${p => styleWithBreakPoints(p, 'BgBlock')};
`;

export const Grid = styled(GridContainer)`
    display: flex;
    margin-top: 150px;
    margin-bottom: 150px;

    @media (max-width: ${breakPoints.mobile}) {
        margin: 40px auto;
    }
`;

export const Row = styled(FlexBoxRow)`
    flex-direction: column;
    max-width: 985px;
    min-width: 280px;
    margin: 0 auto;
    flex: 1 1 auto;
`;

export const Title = styled.div`
    width: 100%;
    font: ${fonts.H2};
    margin-bottom: 15px;
    text-align: left;

    @media (max-width: ${breakPoints.tablet}) {
        font: ${fonts.H3};
    }

    ${p => styleWithBreakPoints(p, 'BgBlock.Title')};
`;

export const Description = styled.div`
    width: 100%;
    font: ${fonts.S};
    margin-bottom: 0;
    text-align: left;

    ${p => styleWithBreakPoints(p, 'BgBlock.Description')};
`;
